import React, { useEffect } from "react";
import AddBXP from "./AddBXP";
import { getSkills } from "../../../../redux/categary/action";
import { useDispatch, useSelector } from "react-redux";

export default function PostBXP() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSkills());
  }, []);
  const skillsss = useSelector(({ categary: { skilllist } }) => skilllist);

  const skills = useSelector((state) => state.categary.skilllist); // Adjust according to your actual state structure

  return (
    <div className ="row about-row">
      <div className ="col-lg-4    about-left">
        <h6>
          01/03<span>Create a post</span>
        </h6>
        <h2>Let’s create your post with a title first</h2>
        <p>Choose a clear and strong title</p>
      </div>
      <div className ="col-md-5">
        <AddBXP />
      </div>
    </div>
  );
}
